import { Amplify } from "aws-amplify"
import {nonprod_aws_cognito_config} from "./config";
Amplify.configure(nonprod_aws_cognito_config)